import type { UsListsUnavailable } from './usListsState';

/** #1238 5a — the one Retry beside "Polymarket US … unavailable" in the
 * Tracker's empty lists. US-only on purpose: the 10 s re-read never re-lists
 * the accounts or re-opens a refused one, so without it the failure would
 * stand for the visit. While a re-read is in flight it stays in place and
 * keeps focus (`aria-disabled`, not `disabled`; the #1060 rule), reading
 * "Retrying…". The code is in the hover, never in the line. */
export function UsUnavailableRetry({ state }: { state: UsListsUnavailable }) {
  const { retry, retrying, code } = state;
  if (!retry) return null;
  return (
    <button
      type="button"
      onClick={retrying ? undefined : retry}
      aria-disabled={retrying || undefined}
      aria-busy={retrying || undefined}
      title={`Polymarket US could not be read (${code}). The 10 s re-read never re-lists the accounts or re-opens a refused one; Retry does.`}
      // Sized for "Retrying…", so the label change never re-wraps its line.
      className="border-border hover:bg-muted ml-2 min-w-[4.75rem] rounded border px-1.5 text-center text-xs aria-disabled:opacity-60"
    >
      {retrying ? 'Retrying…' : 'Retry'}
    </button>
  );
}
